module.exports = __webpack_public_path__ + "static/media/bundle_bg_A.9ece6ac9.png";